<template>
  <main class="content container">
    <div class="content__top">
      <ul class="breadcrumbs">
        <li class="breadcrumbs__item">
          <router-link class="breadcrumbs__link" :to="{ name: 'main' }">
            Каталог
          </router-link>
        </li>
        <li class="breadcrumbs__item">
          <router-link class="breadcrumbs__link" :to="{ name: 'cart' }">
            Корзина
          </router-link>
        </li>
        <li class="breadcrumbs__item">
          <a class="breadcrumbs__link">
            Оформление заказа
          </a>
        </li>
      </ul>

      <div class="content__row">
        <h1 class="content__title">
          Оформление заказа
        </h1>
      </div>
    </div>

    <section class="cart">
      <form class="cart__form form" action="#" method="POST" @submit.prevent="order">
        <div class="cart__field">
          <div class="cart__data">
            <BaseFormText v-model="formData.name" title="ФИО" type="text" :error="formError.name"
              placeholder="Введите ваше полное имя" />

            <BaseFormText v-model="formData.address" title="Адрес доставки" type="text" :error="formError.address"
              placeholder="Введите ваш адрес" />

            <BaseFormText v-model="formData.phone" title="Телефон" type="tel" :error="formError.phone"
              placeholder="Введите ваш телефон" />

            <BaseFormText v-model="formData.email" title="Email" type="email" :error="formError.email"
              placeholder="Введи ваш Email" />

            <BaseFormTextarea v-model="formData.comment" title="Комментарий к заказу" :error="formError.comment"
              placeholder="Ваши пожелания" />
          </div>

          <div class="cart__options">
            <h3 class="cart__title">Доставка</h3>
            <div class="deliveryLoading" v-if="deliveryLoading">
              <p>Загрузка способов доставки</p>
              <img src="../../public/img/Spinner-pink2.svg">
            </div>
            <div class="error-loading-delivery" v-else-if="deliveryLoadingFailed">Не удалось загрузить способы оплаты
            </div>
            <div class="cart__options options" v-else>
              <div class="options__item" v-for="delivery in deliveriesData" :key="delivery.id">
                <label class="options__label">
                  <input class="options__radio sr-only" type="radio" name="delivery" :value="delivery"
                    v-model="selectedValueDelivery" @change.prevent="loadPayments(delivery.id)">
                  <span class="options__value">
                    {{ delivery.title }} <b>{{ delivery.price }} ₽</b>
                  </span>
                </label>
              </div>
            </div>

            <h3 class="cart__title" v-if="selectedValueDelivery != null">Оплата</h3>
            <div class="deliveryLoading" v-if="paymentLoading">
              <p>Загрузка способов оплаты</p>
              <img src="../../public/img/Spinner-pink2.svg">
            </div>
            <div class="error-loading-payment" v-else-if="paymentLoadingFailed">Не удалось загрузить способы оплаты</div>
            <div class="cart__options options" v-else>
              <div class="options__item" v-for="payment in paymentsData" :key="payment.id">
                <label class="options__label">
                  <input class="options__radio sr-only" type="radio" name="pay" :value="payment.id"
                    v-model="selectedValuePayment">
                  <span class="options__value">
                    {{ payment.title }}
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="cart__block">
          <div class="cart__orders">
            <div class="cart__order" v-for="item in products" :key="item.productId" :item="item">
              <h3>{{ item.product.title }}</h3>
              <b>{{ (item.amount * item.product.price) | numberFormat }} ₽</b>
              <span>Артикул: {{ item.product.id }}</span>
            </div>
          </div>

          <div class="cart__total" v-if="this.selectedValueDelivery != null">
            <p>Доставка: <b> {{ this.selectedValueDelivery.price }} ₽ </b></p>
            <p>Итого: <b> {{ $store.state.cartProducts.length }}</b> товар(а) на сумму <b>{{ (Number(totalPrice) +
              Number(this.selectedValueDelivery.price)) | numberFormat }}
                ₽</b></p>
          </div>

          <button class="cart__button button button--primery" type="submit">
            Оформить заказ
          </button>

          <div class="preloadOrdering" v-if="orderingCart">
            <p>Оформление заказа</p>
            <img src="../../public/img/Spinner-pink2.svg">
          </div>

        </div>
        <div class="cart__error form__error-block" v-if="error">
          <h4>Заявка не отправлена!</h4>
          <p>
            Похоже произошла ошибка. Попробуйте отправить снова или перезагрузите страницу.
          </p>
        </div>
      </form>
    </section>
  </main>
</template>
<script>
import BaseFormText from '@/components/BaseFormText.vue';
import BaseFormTextarea from '@/components/BaseFormTextarea.vue';
import numberFormat from '@/helpers/numberFormat';
import { mapGetters } from 'vuex';
import axios from 'axios';
import { API_BASE_URL } from "@/config";

export default {
  components: { BaseFormText, BaseFormTextarea },
  data() {
    return {
      formData: {},
      error: false,
      formError: {},
      orderingCart: false,
      deliveriesData: [],
      selectedValueDelivery: null,
      paymentsData: [],
      selectedValuePayment: null,
      deliveryLoading: false,
      paymentLoading: false,
      deliveryLoadingFailed: false,
      paymentLoadingFailed: false
    }
  },
  filters: { numberFormat },
  computed: {
    ...mapGetters({ products: 'cartDetailProducts', totalPrice: 'cartTotalPrice' }),
  },
  methods: {
    order() {
      if (this.selectedValueDelivery != null && this.selectedValuePayment != null) {
        this.formData.deliveryTypeId = this.selectedValueDelivery.id;
        this.formData.paymentTypeId = this.selectedValuePayment;
      }
      this.orderingCart = true;
      clearTimeout(this.loadCartTimer);
      this.loadCartTimer = setTimeout(() => {
        this.error = false;
        this.formError = {};
        axios
          .post(API_BASE_URL + `/api/orders`, {
            ...this.formData
          }, {
            params: {
              userAccessKey: this.$store.state.userAccessKey
            }
          })
          .then((response) => {
            this.$store.commit('resetCart');
            this.$store.commit('updateOrderInfo', response.data);
            this.$router.push({ name: 'orderInfo', params: { id: response.data.id } });
          })
          .catch(error => {
            this.formError = error.response.data.error.request || {};
            this.error = true;
          })
          .then(() => {
            this.orderingCart = false;
          })
      }, 3000);
    },
    loadDeliveries() {
      this.deliveryLoading = true;
      this.deliveryLoadingFailed = false;
      setTimeout(() => {
        axios.get(API_BASE_URL + `/api/deliveries`)
          .then(response => {
            this.deliveriesData = response.data
          })
          .catch(() => this.deliveryLoadingFailed = true)
          .then(() => this.deliveryLoading = false);
      }, 3000)
    },
    loadPayments(id) {
      this.paymentLoading = true;
      this.paymentLoadingFailed = false;
      setTimeout(() => {
        axios.get(API_BASE_URL + `/api/payments`, {
          params: {
            deliveryTypeId: id,
          }
        })
          .then(response => {
            this.paymentsData = response.data
          })
          .catch(() => this.paymentLoadingFailed = true)
          .then(() => this.paymentLoading = false);
      }, 3000)
    },
  },
  created() {
    this.loadDeliveries()
  }
}
</script>

<style>
.preloadOrdering {
  display: flex;
  color: #e02d71;
}

.preloadOrdering img {
  justify-content: end;
  margin-left: 10px;
  width: 40px;
}

.deliveryLoading img,
.paymentLoading img {
  height: 20px;
}
</style>
